module.exports = __webpack_public_path__ + "img/_85C9083.b63294db.jpeg";